<template>
  <v-dialog
    v-model="open"
    max-width="800"
    overlay-color="primary"
    content-class="payment-plan-dialog"
  >
    <v-card class="payment-plan-card">
      <div class="payment-plan-card__header">
        <div class="payment-plan-card__titles">
          <h3 class="payment-plan-card__title today-medium">
            Plan de pagos
          </h3>
          <p class="payment-plan-card__subtitle today-light">
            {{ formatCurrency(totalValuePolicy) }} a {{ feeNumber }} meses
          </p>
        </div>
        <v-btn
          class="payment-plan-card__close today-medium"
          elevation="0"
          text
          aria-label="Cerrar plan de pagos"
          @click="open = false"
        >
          Cerrar
        </v-btn>
      </div>
      <v-simple-table class="payment-plan-table" dense fixed-header height="320px">
        <template v-slot:default>
          <thead>
            <tr>
              <th>Cuota</th>
              <th>Fecha de corte</th>
              <th>Valor</th>
              <th>Capital</th>
              <th>Corrientes</th>
              <th>Saldo final</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in payPlan" :key="item.nro_cuota">
              <td>{{ item.nro_cuota }}</td>
              <td>{{ formatDate(item.fecha_vence) }}</td>
              <td>{{ formatCurrency(item.cuota) }}</td>
              <td>{{ formatCurrency(item.abono_capital) }}</td>
              <td>{{ formatCurrency(item.interes_corriente) }}</td>
              <td>{{ formatCurrency(item.saldo_final) }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-dialog>
</template>
<script>
import { formatCurrency, formatDate } from "@/helpers/constants";

export default {
  name: "PaymentPlan",
  props: {
    payPlan: Array,
    totalValuePolicy: Number,
    feeNumber: Number,
    dialog: Boolean
  },
  data() {
    return {
      open: this.dialog
    };
  },
  methods: {
    formatCurrency: formatCurrency,
    formatDate: formatDate
  },
  watch: {
    dialog(value) {
      this.open = value;
    },
    open(value) {
      if (!value) {
        this.$emit("close");
      }
    }
  }
};
</script>
<style lang="scss">
.payment-plan-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  overscroll-behavior: contain;
}

.payment-plan-card {
  border-radius: 20px !important;
  overflow: hidden;
  padding: 20px 20px 16px;
}

.payment-plan-card__header {
  align-items: flex-start;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 16px;
}

.payment-plan-card__titles {
  min-width: 0;
}

.payment-plan-card__title {
  color: #00205b;
  font-size: 1rem;
  letter-spacing: 0.02em;
  margin: 0;
  text-wrap: balance;
}

.payment-plan-card__subtitle {
  color: rgba(0, 0, 0, 0.64);
  font-size: 0.875rem;
  font-variant-numeric: tabular-nums;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
}

.payment-plan-card__close {
  color: #00205b !important;
  flex-shrink: 0;
  height: 44px !important;
  letter-spacing: 0 !important;
  min-width: 44px;
  text-transform: none !important;
  touch-action: manipulation;
}

.payment-plan-card__close:focus-visible {
  outline: 2px solid #00205b;
  outline-offset: 3px;
}

.payment-plan-table {
  border: 1px solid #e6e8ee;
  border-radius: 12px;
  overflow: hidden;

  table {
    border-collapse: collapse;
  }

  thead th {
    background: #00205b !important;
    box-shadow: none !important;
    color: #ffffff !important;
    font-family: "HelveticaNeue-Medium", "Roboto-Medium", sans-serif;
    font-size: 0.75rem;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-align: right;
    white-space: nowrap;

    &:first-child,
    &:nth-child(2) {
      text-align: center;
    }
  }

  tbody td {
    border: none !important;
    font-variant-numeric: tabular-nums;
    text-align: right;
    white-space: nowrap;

    &:first-child,
    &:nth-child(2) {
      text-align: center;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f6f7fb !important;
  }
}

@media (max-width: 600px) {
  .payment-plan-card {
    padding: 16px 12px 12px;
  }

  .payment-plan-card__header {
    align-items: center;
  }
}
</style>
